<template>
  <div class="home" :class="{lan_En : lan != 'zh', lan_Ru: lan == 'ru'}">
    <!-- DeepBrainChain 3.0 预告横幅 -->
    <div class="dbc3_announcement">
      <div class="dbc3_bg_particles">
        <span v-for="n in 20" :key="n" class="particle"></span>
      </div>
      <div class="dbc3_content">
        <div class="dbc3_badge">COMING SOON</div>
        <h1 class="dbc3_title">
          <span class="dbc3_text_gradient">DeepBrainChain 3.0</span>
        </h1>
        <p class="dbc3_tagline">BOT-Native AI Chain</p>
        <div class="dbc3_mystery">
          <div class="mystery_item">
            <span class="mystery_icon">?</span>
            <span class="mystery_text">{{ lan === 'zh' ? '革命性共识机制' : 'Revolutionary Consensus' }}</span>
          </div>
          <div class="mystery_item">
            <span class="mystery_icon">?</span>
            <span class="mystery_text">{{ lan === 'zh' ? '原生 BOT 交易支持' : 'Native BOT Trading' }}</span>
          </div>
          <div class="mystery_item">
            <span class="mystery_icon">?</span>
            <span class="mystery_text">{{ lan === 'zh' ? '自动化 AI Agent 执行' : 'Automated AI Agent Execution' }}</span>
          </div>
        </div>
        <div class="dbc3_teaser">
          <p class="teaser_text">{{ lan === 'zh' ? '当 AI 拥有自己的区块链，会发生什么？' : 'What happens when AI has its own blockchain?' }}</p>
          <p class="teaser_subtext">{{ lan === 'zh' ? '答案即将揭晓...' : 'The answer is coming...' }}</p>
        </div>
        <div class="dbc3_cta">
          <a class="cta_btn primary" href="https://github.com/DeepBrainChain" target="_blank">
            <span>{{ lan === 'zh' ? '探索 GitHub' : 'Explore GitHub' }}</span>
            <span class="btn_arrow">→</span>
          </a>
          <a class="cta_btn secondary" href="https://x.com/DeepBrainChain" target="_blank">
            <span>{{ lan === 'zh' ? '关注最新动态' : 'Follow Updates' }}</span>
          </a>
        </div>
      </div>
      <div class="dbc3_glow"></div>
    </div>

    <div class="content1">
      <div class="banner_content">
        <div class="content1_bg1" >
          <img class="banner" src="../assets/new_home/banner.png" alt="">
          <img class="base" src="../assets/new_home/banner_bottom.png" alt="">
        </div>
        <div class="introduce">
          <p class="text1 delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">{{ $t('home.cont1.text1') }}</p>
          <p class="text2 delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">{{ $t('home.cont1.text2') }}</p>
          <p class="text3 delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">{{ $t('home.cont1.text2_1') }}</p>
        </div>
      </div>
    </div>
    <div class="dbc_intro">
      <div class="top_info">
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
        <div class="dbc_logo">
          <p>DeepBrain Chain 2.0</p>
          <div class="img"></div>
        </div>
      </div>
      <div class="intro_text delay100 animateHide" v-animate="{delay: 100, class:'fadeInRight'}">
        {{ $t('home.cont1.text3') }}, {{ $t('home.cont1.text4') }}, {{ $t('home.cont1.text5') }}
      </div>
      <div class="intro_btn delay300 animateHide" v-animate="{delay: 300, class:'fadeInRight'}" @click="linkHref2('/learnDBC')">
        {{ $t('home.dbc_intro.text') }} <span class="arrow">→</span>
      </div>
    </div>
    <!-- Meme Coin 区块已隐藏
    <div class="meme_intro delay100 animateHide" v-animate="{delay: 100, class:'fadeInDown'}">
      <div class="top_info">
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
      </div>
      <div class="meme_title">{{ $t('home.cont1_1.title') }}</div>
      <div class="intro_text">
        {{ $t('home.cont1_1.text1') }}{{ $t('home.cont1_1.text2') }}{{ $t('home.cont1_1.text3') }}{{ $t('home.cont1_1.text4') }}
      </div>
      <div class="contract">
        <p class="contract_text">{{ $t('home.cont1_1.text5') }}</p>
        <p class="contract_address">
          <span>{{ `${'0x4444140f59535d58b165f71667765228d9308f3f'.slice(0, 4)}...${'0x4444140f59535d58b165f71667765228d9308f3f'.slice(-4)}` }}</span> <span class="icon" @click="copyClipboard('0x4444140f59535d58b165f71667765228d9308f3f')"></span>
        </p>
      </div>
    </div>
    -->
    <div class="content2">
      <div class="cont_swap">
        <el-carousel class="carousel delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}" :interval="5000" arrow="always" height="700px">
          <!-- <el-carousel-item>
            <div class="sliper">
              <div class="sliper_left">
                <p class="sliper_text">{{ $t('home.cont2.title4') }}</p>
                <p class="sliper_text1">{{ $t('home.cont2.title4_1') }}</p>
                <div class="sliper_btn" @click="linkHerf('https://www.deeplink.cloud/public-sale/')">{{ $t('home.cont2.text4') }}</div>
              </div>
              <div class="sliper_right"><img src="../assets/home/comp4.png" alt=""></div>
            </div>
          </el-carousel-item> -->
          <el-carousel-item>
            <div class="sliper">
              <div class="sliper_left">
                <p class="sliper_text">{{ $t('home.cont2.title1') }}</p>
                <div class="sliper_btn" @click="seeVideo(1)">{{ $t('home.cont2.text1') }}</div>
              </div>
              <div class="sliper_right"><img src="../assets/home/comp3.jpg" alt=""></div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="sliper">
              <div class="sliper_left">
                <p class="sliper_text">{{ $t('home.cont2.title2') }}</p>
                <div class="sliper_btn" @click="linkHerf('https://galaxyrace.deepbrainchain.org/')">{{ $t('home.cont2.text2') }}</div>
              </div>
              <div class="sliper_right"><img class="marginL" src="../assets/home/comp1.png" alt=""></div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="sliper">
              <div class="sliper_left">
                <p class="sliper_text">{{ $t('home.cont2.title3') }}</p>
                <div class="sliper_btn" @click="seeVideo(2)">{{ $t('home.cont2.text3') }}</div>
              </div>
              <div class="sliper_right"><img src="../assets/home/comp2.png" alt=""></div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="content3">
      <div class="top_info">
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
      </div>
      <div class="cont3_title">{{ $t('home.cont3.title') }}</div>
      <div class="cont3_desc">{{ $t('home.cont3.text') }}</div>
      <div class="cont3_swap delay300 animateHide" v-animate="{delay: 300, class:'fadeInRight'}">
        <el-scrollbar>
          <div class="ecologyList">
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/deeplink.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.deeplink.cloud/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title1') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text1') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/degpt.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.decentralgpt.org/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title2') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text2') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/superimg.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.superimage.ai/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title3') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text3') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/drcpad.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.drcpad.io/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title4') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text4') }}</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="cont3_swap delay300 animateHide" v-animate="{delay: 300, class:'fadeInLeft'}">
        <el-scrollbar ref="scrollbarRef">
          <div class="ecologyList">
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/hycons.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.hycons.cloud"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title5') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text5') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/websub.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://dbc.subscan.io/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title6') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text6') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/deepbrainchain.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://dbcscan.io/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title7') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text7') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/xai.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://xaiagent.io/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title9') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text9') }}</div>
            </div>
            <div class="ecologyLi">
              <div class="ecolog_top">
                <div class="logo_img"><img src="../assets/new_home/deepbrainchain.png" alt=""></div>
                <a class="link_img" target="_blank" href="https://www.dbcwallet.io/"></a>
              </div>
              <div class="ecology_title">{{ $t('home.cont3.title8') }}</div>
              <div class="ecology_text">{{ $t('home.cont3.text8') }}</div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div class="unifycontent" @wheel="handleScroll">
      <div class="content4">
        <div class="top_info">
          <div class="point_list">
            <div class="point point1"></div>
            <div class="point point2"></div>
          </div>
        </div>
        <div class="cont4_title">{{ $t('home.cont4.title') }}</div>
        <div class="cont4_desc">{{ $t('home.cont4.text') }}</div>
        <div class="numberList">
          <div class="number_block w25">
            <div class="number num1">
              <count-to ref='count_start1' :startVal='0' :endVal='Number_inc.count1' :duration='3000'></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text1') }}</div>
          </div>
          <div class="number_block w25">
            <div class="number num2">
              <count-to ref='count_start2' :decimals="2" decimal="." :startVal='0' :endVal='Number_inc.count2' :duration='3000' suffix="%"></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text2') }}</div>
          </div>
          <div class="number_block w25">
            <div class="number num3">
              <count-to ref='count_start3' :startVal='0' :endVal='Number_inc.count3' :duration='3000'></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text3') }}</div>
          </div>
          <div class="number_block w25">
            <div class="number num4">
              <count-to ref='count_start4' :startVal='0' :endVal='Number_inc.count4' :duration='3000'></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text4') }}</div>
          </div>
          <div class="number_block w33">
            <div class="number num1">
              <count-to ref='count_start5' :decimals="4" decimal="." :startVal='0' :endVal='Number_inc.count5' :duration='3000' suffix="B"></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text5') }}</div>
          </div>
          <div class="number_block w33">
            <div class="number num2">
              <count-to ref='count_start6' :startVal='0' :endVal='Number_inc.count6' :duration='3000'></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text6') }}</div>
          </div>
          <div class="number_block w33">
            <div class="number num3">
              <count-to ref='count_start7' :decimals="4" decimal="." :startVal='0' :endVal='Number_inc.count7' :duration='3000' :suffix="Number_inc.count7_unit"></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text7') }}</div>
          </div>
          <div class="number_block w50">
            <div class="number num4">
              <count-to ref='count_start8' :decimals="4" decimal="." :startVal='0' :endVal='Number_inc.count8' :duration='3000' :suffix="Number_inc.count8_unit"></count-to>
            </div>
            <div class="num_desc">{{ $t('home.cont4.text8') }}</div>
          </div>
        </div>
      </div>
      <div class="content5">
        <div class="left">
          <p class="title">{{ $t('home.cont5.title') }}</p>
          <!-- <p class="text">{{ $t('home.cont5.text') }}</p> -->
          <p></p>
        </div>
        <div class="right">
          <div class="list">
            <div class="listInfo delay500 animateHide" v-animate="{delay: 500, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose1.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block1.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block1.text') }}</div>
            </div>
            <div class="listInfo delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose2.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block2.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block2.text') }}</div>
            </div>
            <div class="listInfo delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose3.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block3.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block3.text') }}</div>
            </div>
          </div>
          <div class="list">
            <div class="listInfo delay900 animateHide" v-animate="{delay: 900, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose4.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block4.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block4.text') }}</div>
            </div>
            <div class="listInfo delay600 animateHide" v-animate="{delay: 600, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose5.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block5.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block5.text') }}</div>
              <div class="text2">{{ $t('home.cont5.block5.text1') }}</div>
            </div>
            <div class="listInfo delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">
              <div class="top_img"><img src="../assets/new_home/choose6.png" alt=""></div>
              <div class="text1">{{ $t('home.cont5.block6.title') }}</div>
              <div class="text2">{{ $t('home.cont5.block6.text') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content6"> 
      <div class="cont6_con">
        <div class="left">
          <div class="cont6_title">{{ $t('home.cont6.title') }}</div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block1.text') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block2.text') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block2.text1') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block3.text') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block3.text1') }}</p></div>
          <div class="token_text"><span class="icon"></span>
            <p>{{ $t('home.cont6.block4.text', {stakeNum: totalNum.Stake.toLocaleString(), ratio: totalNum.Stake_ratio}) }}</p>
          </div>
          <div class="token_text"><span class="icon"></span>
            <p>{{ $t('home.cont6.block5.text', {stakeNum: Number_inc.count3.toLocaleString(), ratio: totalNum.Issuance_ratio}) }}</p>
          </div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block6.text') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block6.text1') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block6.text2') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block6.text3') }}</p></div>
          <div class="token_text"><span class="icon"></span><p>{{ $t('home.cont6.block6.text4') }}</p></div>
        </div>
        <div class="right">
          <div class="right_bg"></div>
          <img src="../assets/new_home/cont6_icon.png" alt="">
        </div>
      </div>
    </div>
    <div class="content7">
      <div class="bg1"></div>
      <div class="bg2"></div>
      <div class="bg3"></div>
      <div class="bg4"></div>
      <div class="cont_title">{{ $t('home.cont7.title') }}</div>
      <div class="exchange">
        <a class="exchange_li" target="_blank" href="https://www.gate.tv/trade/DBC_USDT"><img src="../assets/new_home/gate.png" alt=""></a>
        <a class="exchange_li" target="_blank" href="https://swap.swft.pro/#/"><img src="../assets/new_home/swft.png" alt=""></a>
        <a class="exchange_li" target="_blank" href="https://app.uniswap.org/swap?outputCurrency=0x1F735f84b07cc20E9aC471C291a87b5A2428d518&chain=ethereum"><img src="../assets/new_home/uniswap.png" alt=""></a>
        <a class="exchange_li" target="_blank" href="https://www.bitmart.com/trade/en-US?layout=pro&theme=dark&symbol=DBC_USDT"><img src="../assets/new_home/bitmart.png" alt=""></a>
        <!-- <a class="exchange_li" target="_blank" href="https://www.mexc.com/exchange/DBC_USDT?_from=search_spot_trade"><img class="mexc" src="../assets/new_home/mexc.png" alt=""></a> -->
      </div>
      <div class="contract">
        <p class="contract_text">{{ $t('home.cont7.text3') }}</p>
        <p class="contract_address">
          <span>{{ `${'0x1F735f84b07cc20E9aC471C291a87b5A2428d518'.slice(0, 4)}...${'0x1F735f84b07cc20E9aC471C291a87b5A2428d518'.slice(-4)}` }}</span> <span class="icon" @click="copyClipboard('0x4444140f59535d58b165f71667765228d9308f3f')"></span>
        </p>
      </div>
      <div class="contract_token">
        <p class="token_test">{{ $t('home.cont7.text1') }} <span>15</span></p>
        <p class="token_test">{{ $t('home.cont7.text2') }} <span>DBC</span></p>
      </div>
    </div>
    <div class="content8">
      <div class="cont_title">{{ $t('home.cont8.title') }}</div>
      <div class="cont_desc">{{ $t('home.cont8.text1') }}</div>
      <div class="cont_table delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">
        <table class="table_cont">
          <tr class="theader">
            <th class="width210" colspan="2">{{ $t('home.cont8.table.tr1') }}</th>
            <th class="color1">{{ $t('home.cont8.table.tr2') }}</th>
            <th class="color1">{{ $t('home.cont8.table.tr3') }}</th>
            <th class="color2">{{ $t('home.cont8.table.tr4') }}</th>
            <th class="color2">{{ $t('home.cont8.table.tr5') }}</th>
            <th class="color2">{{ $t('home.cont8.table.tr6') }}</th>
            <th class="width240">{{ $t('home.cont8.table.tr7') }}</th>
          </tr>
          <tr>
            <td colspan="2">{{ $t('home.cont8.table.tbody1.text1') }}</td>
            <td class="color1">15%</td>
            <td class="color1">15%</td>
            <td v-show="lan == 'zh'" class="color2">15</td>
            <td v-show="lan != 'zh'" class="color2">1.5</td>
            <td v-show="lan == 'zh'" class="color2">15</td>
            <td v-show="lan != 'zh'" class="color2">1.5</td>
            <td class="color2">-</td>
            <td class="font16">{{ $t('home.cont8.table.tbody1.text2') }}</td>
          </tr>
          <tr>
            <td class="width60" rowspan="2" style="width: 20px;">{{ $t('home.cont8.table.tbody2.text') }}</td>
            <td>{{ $t('home.cont8.table.tbody2.text1') }}</td>
            <td class="color1">17.35%</td>
            <td class="color1" rowspan="2">25%</td>
            <td v-show="lan == 'zh'" class="color2">17.35</td>
            <td v-show="lan == 'zh'" class="color2">11.96</td>
            <td v-show="lan == 'zh'" class="color2">5.39</td>
            
            <td v-show="lan != 'zh'" class="color2">1.735</td>
            <td v-show="lan != 'zh'" class="color2">1.196</td>
            <td v-show="lan != 'zh'" class="color2">0.539</td>
            <td class="font16">{{ $t('home.cont8.table.tbody2.text2') }}</td>
          </tr>
          <tr>
            <td>{{ $t('home.cont8.table.tbody3.text1') }}</td>
            <td class="color1">7.65%</td>
            <!-- <td class="color1">25%</td> -->
            <td v-show="lan == 'zh'" class="color2">7.65</td>
            <td v-show="lan == 'zh'" class="color2">1.53</td>
            <td v-show="lan == 'zh'" class="color2">6.12</td>

            <td v-show="lan != 'zh'" class="color2">0.765</td>
            <td v-show="lan != 'zh'" class="color2">0.153</td>
            <td v-show="lan != 'zh'" class="color2">0.612</td>
            <td class="font16">{{ $t('home.cont8.table.tbody3.text2') }}</td>
          </tr>

          <tr>
            <td colspan="2">{{ $t('home.cont8.table.tbody4.text1') }}</td>
            <td class="color1">10%</td>
            <td class="color1">10%</td>
            <td v-show="lan == 'zh'" class="color2">10</td>
            <td v-show="lan == 'zh'" class="color2">8</td>
            <td v-show="lan == 'zh'" class="color2">2</td>

            <td v-show="lan != 'zh'" class="color2">1</td>
            <td v-show="lan != 'zh'" class="color2">0.8</td>
            <td v-show="lan != 'zh'" class="color2">0.2</td>
            <td class="font16">{{ $t('home.cont8.table.tbody4.text2') }}</td>
          </tr>
          <tr>
            <td colspan="2">{{ $t('home.cont8.table.tbody5.text1') }}</td>
            <td class="color1">10%</td>
            <td class="color1">10%</td>
            <td v-show="lan == 'zh'" class="color2">10</td>
            <td v-show="lan == 'zh'" class="color2">10</td>
            <td v-show="lan != 'zh'" class="color2">1</td>
            <td v-show="lan != 'zh'" class="color2">1</td>
            <td class="color2">-</td>
            <td class="font16">{{ $t('home.cont8.table.tbody5.text2') }}</td>
          </tr>
          <tr>
            <td class="width60" rowspan="2" style="width: 20px;">{{ $t('home.cont8.table.tbody6.text') }}</td>
            <td>{{ $t('home.cont8.table.tbody6.text1') }}</td>
            <td class="color1">8%</td>
            <td class="color1" rowspan="2">40%</td>
            <td v-show="lan == 'zh'" class="color2">8</td>
            <td v-show="lan == 'zh'" class="color2">3</td>
            <td v-show="lan == 'zh'" class="color2">5</td>
            <td v-show="lan != 'zh'" class="color2">0.8</td>
            <td v-show="lan != 'zh'" class="color2">0.3</td>
            <td v-show="lan != 'zh'" class="color2">0.5</td>
            <td class="font16">{{ $t('home.cont8.table.tbody6.text2') }}</td>
          </tr>
          <tr>
            <td>{{ $t('home.cont8.table.tbody7.text1') }}</td>
            <td class="color1">32%</td>
            <!-- <td class="color1">40%</td> -->
            <td v-show="lan == 'zh'" class="color2">32</td>
            <td v-show="lan == 'zh'" class="color2">12</td>
            <td v-show="lan == 'zh'" class="color2">20</td>
            <td v-show="lan != 'zh'" class="color2">3.2</td>
            <td v-show="lan != 'zh'" class="color2">1.2</td>
            <td v-show="lan != 'zh'" class="color2">2.0</td>
            <td class="font16">{{ $t('home.cont8.table.tbody7.text2') }}</td>
          </tr>
          <tr class="tfooter">
            <td colspan="2">{{ $t('home.cont8.table.tbody8.text1') }}</td>
            <td class="color1" colspan="2" style="text-align: center;">100%</td>
            <!-- <td class="color1">15%</td> -->
            <td v-show="lan == 'zh'" class="color2">100</td>
            <td v-show="lan == 'zh'" class="color2">61.49</td>
            <td v-show="lan == 'zh'" class="color2">38.51</td>
            <td v-show="lan != 'zh'" class="color2">10</td>
            <td v-show="lan != 'zh'" class="color2">6.149</td>
            <td v-show="lan != 'zh'" class="color2">3.851</td>
            <td class="font16"></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="content9">
      <div class="cont9_con">
        <div class="cont_title">{{ $t('home.cont9.title') }}</div>
        <div class="partner">
          <div class="partner_li delay100 animateHide" v-animate="{delay: 100, class:'fadeInDown'}">
            <img src="../assets/new_home/partners1.png" alt="">
          </div>
          <div class="partner_li delay200 animateHide" v-animate="{delay: 200, class:'fadeInDown'}">
            <img src="../assets/new_home/partners2.png" alt="">
          </div>
          <div class="partner_li delay300 animateHide" v-animate="{delay: 300, class:'fadeInDown'}">
            <img src="../assets/new_home/partners3.png" alt="">
          </div>
          <div class="partner_li delay400 animateHide" v-animate="{delay: 400, class:'fadeInDown'}">
            <img src="../assets/new_home/partners4.png" alt="">
          </div>
          <div class="partner_li delay500 animateHide" v-animate="{delay: 500, class:'fadeInDown'}">
            <img src="../assets/new_home/partners5.png" alt="">
          </div>
          <div class="partner_li delay600 animateHide" v-animate="{delay: 600, class:'fadeInDown'}">
            <img src="../assets/new_home/partners6.png" alt="">
          </div>
          <div class="partner_li delay100 animateHide" v-animate="{delay: 100, class:'fadeInUp'}">
            <img src="../assets/new_home/partners7.png" alt="">
          </div>
          <div class="partner_li delay200 animateHide" v-animate="{delay: 200, class:'fadeInUp'}">
            <img src="../assets/new_home/partners8.png" alt="">
          </div>
          <div class="partner_li delay300 animateHide" v-animate="{delay: 300, class:'fadeInUp'}">
            <img src="../assets/new_home/partners9.png" alt="">
          </div>
          <div class="partner_li delay400 animateHide" v-animate="{delay: 400, class:'fadeInUp'}">
            <img src="../assets/new_home/partners10.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="content11">
      <div class="top_info">
        <div class="cont11_title">{{ $t('home.cont10.title') }}</div>
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
      </div>
      <el-scrollbar height="540px">
        <div class="cont11_con">
          <div class="roadmap w33">
            <div class="num">{{ $t('historyDBC.title1') }}</div>
            <div class="desc">
              <p>{{ $t('historyDBC.text1_1') }}</p>
              <p>{{ $t('historyDBC.text1_2') }}</p>
            </div>
          </div>
          <div class="roadmap w33">
            <div class="num">{{ $t('historyDBC.title2') }}</div>
            <div class="desc">
              <p>{{ $t('historyDBC.text2_1') }}</p>
              <p>{{ $t('historyDBC.text2_2') }}</p>
              <p>(<a href="https://github.com/DeepBrainChain">https://github.com/DeepBrainChain</a>)</p>
            </div>
          </div>
          <div class="roadmap w33">
            <div class="num">{{ $t('historyDBC.title3') }}</div>
            <div class="desc">
              <p>{{ $t('historyDBC.text3_1') }}</p>
            </div>
          </div>
          <div class="roadmap w50">
            <div class="num">{{ $t('historyDBC.title4') }}</div>
            <div class="desc">
              <p>{{ $t('historyDBC.text4_1') }}</p>
              <p>(<a href="https://www.dbcwallet.io">https://www.dbcwallet.io</a>)</p>
              <p>{{ $t('historyDBC.text4_2') }}</p>
              <p>(<a href="https://dbc.subscan.io">https://dbc.subscan.io</a>)</p>
              <p>{{ $t('historyDBC.text4_3') }}</p>
              <p>{{ $t('historyDBC.text4_4') }}</p>
              <p>{{ $t('historyDBC.text4_5') }}</p>
              <p>(<a href="https://galaxyrace.deepbrainchain.org">https://galaxyrace.deepbrainchain.org</a>)</p>
              <p>{{ $t('historyDBC.text4_6') }}</p>
            </div>
          </div>
          <div class="roadmap w50">
            <div class="num">{{ $t('historyDBC.title5') }}</div>
            <div class="desc">
              <p>{{ $t('historyDBC.text5_1') }}</p>
              <p>{{ $t('historyDBC.text5_2') }}</p>
              <p>(<a href="https://hibaocloud.com" target="_blank">https://hibaocloud.com</a>)</p>
              <p>{{ $t('historyDBC.text5_3') }}</p>
              <p>{{ $t('historyDBC.text5_4') }}</p>
              <p>(<a href="https://www.hycons.cloud" target="_blank">https://www.hycons.cloud</a>)</p>
              <p>{{ $t('historyDBC.text5_5') }}</p>
              <p>(<a href="https://www.deeplink.cloud" target="_blank">https://www.deeplink.cloud</a>)</p>
            </div>
          </div>
          <div class="roadmap w50">
            <div>
              <div class="num">{{ $t('historyDBC.title6') }}</div>
              <div class="desc">
                <p>{{ $t('historyDBC.text6_1') }}</p>
                <p>{{ $t('historyDBC.text6_2') }}</p>
                <p>{{ $t('historyDBC.text6_3') }}</p>
              </div>
            </div>
          </div>
          <div class="roadmap w50">
            <div>
              <div class="num">{{ $t('historyDBC.title7') }}</div>
              <div class="desc">
                <p>{{ $t('historyDBC.text7_1') }}</p>
                <p>{{ $t('historyDBC.text7_2') }}</p>
                <p>{{ $t('historyDBC.text7_3') }}</p>
                <p>{{ $t('historyDBC.text7_4') }}</p>
                <p>{{ $t('historyDBC.text7_5') }}</p>
                <p>{{ $t('historyDBC.text7_6') }}</p>
                <p>{{ $t('historyDBC.text7_7') }}</p>
                <p>{{ $t('historyDBC.text7_8') }}</p>
                <p>{{ $t('historyDBC.text7_9') }}</p>
                <p>{{ $t('historyDBC.text7_10') }}</p>
                <p>{{ $t('historyDBC.text7_11') }}</p>
                <p>{{ $t('historyDBC.text7_12') }}</p>
                <p>{{ $t('historyDBC.text7_13') }}</p>
                <p>{{ $t('historyDBC.text7_14') }}</p>
              </div>
            </div>
          </div>
          <div class="roadmap w100">
            <div>
              <div class="num">{{ $t('historyDBC.title8') }}</div>
              <div class="desc">
                <p>{{ $t('historyDBC.text8_1') }}</p>
                <p>{{ $t('historyDBC.text8_2') }}</p>
                <p>{{ $t('historyDBC.text8_3') }}</p>
                <p>{{ $t('historyDBC.text8_4') }}</p>
                <p>{{ $t('historyDBC.text8_5') }}</p>
                <p>{{ $t('historyDBC.text8_6') }}</p>
                <p>{{ $t('historyDBC.text8_7') }}</p>
                <p>{{ $t('historyDBC.text8_8') }}</p>
                <p>{{ $t('historyDBC.text8_9') }}</p>
                <p>{{ $t('historyDBC.text8_10') }}</p>
                <p>{{ $t('historyDBC.text8_11') }}</p>
                <p>{{ $t('historyDBC.text8_12') }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar> 
    </div>
    <div class="content12">
      <div class="top_info">
        <div class="cont12_title">{{ $t('home.cont12.title') }}</div>
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
      </div>
      <div class="cont12_con">
        <div class="left"><img :src="require(`@/assets/home/${showimg}`)" alt=""></div>
        <div class="right">
          <div class="model"></div>
          <el-scrollbar height="844px">
            <div class="cont12_list">
              <div class="cont12_li" v-for="(el, index) in medialist" @click="chooseMedia(el, index)" :class="{active: chooseIndex == index}">
                <p class="news_title">{{ el.new_title }}</p>
                <p class="text">{{ el.text }}</p>
                <div class="date">
                  <p>{{ el.date }}</p>
                  <a class="icon" target="_blank" :href="el.link"></a>
                </div>
              </div>
            </div>
          </el-scrollbar> 
        </div>
      </div>
    </div>
    <div class="content13">
      <div class="top_info">
        <div class="cont13_title">{{ $t('home.cont13.title') }}</div>
        <div class="point_list">
          <div class="point point1"></div>
          <div class="point point2"></div>
        </div>
      </div>
      <el-carousel :interval="1500" type="card" height="725px">
        <el-carousel-item v-for="(item, index) in eventInfo" :key="index">
          <div class="cont13_cont" @click="linkHerf(item.link)">
            <div class="active_img">
              <img :src="require(`@/assets/home/${item.img_url}`)" alt="">
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.time }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- <div class="event_list">
        <div v-for="(item, index) in eventInfo" class="event_li  animateHide" :class="{delay100: item.delay == 100, delay200: item.delay == 200, delay300: item.delay == 300, delay400: item.delay == 400, delay500: item.delay == 500, delay600: item.delay == 600, delay700: item.delay == 700, delay800: item.delay == 800, delay900: item.delay == 900}" v-animate="{delay: item.delay, class:'fadeInUp'}"  v-show='YTBShow ? index < 12 : index < 100'>
          <div class="event_cont">
            <img :src="require(`@/assets/home/${item.img_url}`)" alt="">
          </div>
          <div class="img_cont" @click="linkHerf(item.link)">
            <div class="img_title">{{ item.title }}</div>
            <div class="img_date">{{ item.time }}</div>
          </div>
        </div>
      </div>
      <div v-if="eventInfo.length > 12" class="seeMore" @click="YTBShow = !YTBShow">{{ YTBShow ? $t('showMore') : $t('hideMore') }}</div> -->
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, computed, watch, onMounted, onBeforeUnmount  } from "vue";
  import { CountTo } from 'vue3-count-to';
  import { getRewardInfo } from '../api/wss'
  import { getHodoler } from '../api/http'
  import { useRoute, useRouter } from 'vue-router'
  import { getTotalIssuance, getTotalstak, getTreasury, getTotalNumber } from '../api/query'
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'Home',
    components: {
      CountTo
    },
    setup() {
      const store = useStore()
      const router = useRouter()
      let lan = computed(() =>  store.state.lan)
      var Number_inc = ref({
        count1: 0,
        count2: 0,
        count3: 0,
        count4: 0,
        count5: 0,
        count6: 0,
        count7: 0,
        count7_unit: '',
        count8: 0,
        count8_unit: ''
      })
      watch(lan, (newvlaue, oldvalue) => {
        console.log(newvlaue, oldvalue, 'ssss');
      })
      const first_entry = ref(true)
      const count_start1 = ref(null)
      const count_start2 = ref(null)
      const count_start3 = ref(null)
      const count_start4 = ref(null)
      const count_start5 = ref(null)
      const count_start6 = ref(null)
      const count_start7 = ref(null)
      const count_start8 = ref(null)
      const doHandleMonth = (month) => {
          var m = month;
          if (month.toString().length == 1) {
              m = "0" + month;
          }
          return m;
      }
      const getDay = (day) => {
          var today = new Date();
          var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
          today.setTime(targetday_milliseconds); //注意，这行是关键代码
          var tYear = today.getFullYear();
          var tMonth = today.getMonth();
          var tDate = today.getDate();
          tMonth = doHandleMonth(tMonth + 1);
          tDate = doHandleMonth(tDate);
          return tYear + "-" + tMonth + "-" + tDate;
      }
      const totalNum = ref({
        Stake: 0,
        Issuance: 0,
        Stake_ratio: 0,
        Issuance_ratio: 0,
      })
      const rewardInfo = ref(null)
      const Total = ref(null)
      const stake_num = ref(null)
      const account = ref(null)
      const holder = ref(null)
      const getNumber = async () => {
        rewardInfo.value = await getRewardInfo();
        Total.value = await getTotalIssuance()
        stake_num.value = await getTotalstak()
        account.value = await getTreasury()
        const total_Number = await getTotalNumber()
        holder.value = await getHodoler({
          "category": "AccountHolderTotal",
          "end": getDay(0),
          "format": "day",
          "start": getDay(-1)
        })
        
        totalNum.value.Stake = Math.floor( total_Number.Stake_data / Math.pow(10, 15))
        totalNum.value.Issuance = Math.floor( total_Number.Issuance_data / Math.pow(10, 15))
        totalNum.value.Stake_ratio = Number(((totalNum.value.Stake / totalNum.value.Issuance )*100).toFixed(2))
        totalNum.value.Issuance_ratio = Number(((Math.floor(rewardInfo.value?.totalStake / Math.pow(10, 15)) / totalNum.value.Issuance )*100).toFixed(2))
      }
      const handleScroll = (event) => {
        Number_inc.value.count1 = rewardInfo.value?.totalGpuNum
        Number_inc.value.count2 = Number(((rewardInfo.value?.totalRentedGpu / rewardInfo.value?.totalGpuNum )*100).toFixed(2))
        Number_inc.value.count3 = Math.floor(rewardInfo.value?.totalStake / Math.pow(10, 15))
        Number_inc.value.count4 = Math.floor(rewardInfo.value?.totalBurnFee / Math.pow(10, 15))
        Number_inc.value.count5 = Number(Total.value&&Total.value.replace(/BDBC/, "").replace(' ', ""))
        Number_inc.value.count6 = Number(holder.value?.data.list ? holder.value?.data.list[holder.value.data.list.length-1].total : 0)
        if (stake_num.value&&stake_num.value.indexOf('MDBC') > 0) {
          Number_inc.value.count7 = Number(stake_num.value.replace(/MDBC/, "").replace(' ', "")) 
          Number_inc.value.count7_unit = 'M'
        } else if (stake_num.value&&stake_num.value.indexOf('BDBC') > 0) {
          Number_inc.value.count7 = Number(stake_num.value.replace(/BDBC/, "").replace(' ', "") )
          Number_inc.value.count7_unit = 'B'
        } else {
          Number_inc.value.count7 = Number(stake_num.value )
          Number_inc.value.count7_unit = ''
        }
        if (account.value&&account.value.indexOf('MDBC') > 0) {
          Number_inc.value.count8 = Number(account.value?.replace(/MDBC/, "").replace(' ', "")) 
          Number_inc.value.count8_unit = 'M'
        } else if (account.value&&account.value.indexOf('BDBC') > 0) {
          Number_inc.value.count8 = Number(account.value?.replace(/BDBC/, "").replace(' ', "") )
          Number_inc.value.count8_unit = 'B'
        } else {
          Number_inc.value.count8 = Number(account.value?.replace(/DBC/, "").replace(' ', "") )
          Number_inc.value.count8_unit = ''
        }
        if (first_entry.value) {
          count_start1.value.start();
          count_start2.value.start();
          count_start3.value.start();
          count_start4.value.start();
          count_start5.value.start();
          count_start6.value.start();
          count_start7.value.start();
          count_start8.value.start();
          first_entry.value = false
        }
      }
      const ball_show = ref(true)
      const CurrentHeight = ref(0)
      const handleScroll1 = () => {
        CurrentHeight.value = document.body.scrollTop || document.documentElement.scrollTop
        if (CurrentHeight.value < 900) {
          ball_show.value = true
        } else {
          ball_show.value = false
        }
      }

      const visibilityChange = () => {
        if (document.hidden) {
          ball_show.value = false
        } else {
          if (CurrentHeight.value < 700) {
            ball_show.value = true
          } else {
            ball_show.value = false
          }
        }
      }
      const seeVideo = (type) => {
        if (type == 1) {
          window.open('/web3.mp4')
        } else {
          window.open('/DBC_Pitch_Deck.pdf')
        }
      }
      const YTBShow = ref(true)
      const eventInfo = ref([
        {
          title: "DBC participated in the 1012EXPO Big Navigation Blockchain Conference, a standout event focused on future tech trends and innovative collaboration models.",
          time: '17/10 2024',
          link: 'https://x.com/deepbrainfeng/status/1846490905043521916',
          delay: 200,
          img_url: 'cont13_bg30.jpg'
        },
        {
          title: "DeepBrain Chain at the Singapore Token2049. ",
          time: '18/09 2024',
          link: 'https://x.com/DeepBrainChain/status/1836387111114879067',
          delay: 200,
          img_url: 'cont13_bg29.jpg'
        },
        {
          title: "DeepBrainChain and DeepLinkGlobal Signs Strategic Cooperation Agreement with IPCA to Promote the Application of AI and Blockchain Technology in Korean Internet Cafe Industry",
          time: '10/09 2024',
          link: 'https://x.com/DeepBrainChain/status/1833739141290623405',
          delay: 200,
          img_url: 'cont13_bg28.jpg'
        },
        {
          title: "DeepBrain Chain successfully attended and completed the Web X event in Tokyo, Japan.",
          time: '02/09 2024',
          link: 'https://x.com/DeepBrainChain/status/1830534976254746764',
          delay: 300,
          img_url: 'cont13_bg27.jpg'
        },
        {
          title: "DeepBrain Chain (DBC) successfully hosted the “Future of Decentralized AI” summit at Stanford University.",
          time: '28/07 2024',
          link: 'https://x.com/DeepBrainChain/status/1817793793154011213',
          delay: 300,
          img_url: 'cont13_bg26.jpg'
        },
        // {
        //   title: 'DeepLink’s Cornerstone Investor Mr. Adam Ha, participated in the DEPIN ALLIANCE YACHT PARTY ⛵️panel and introduced DeepLink to the Vietnam market.',
        //   time: '07/06 2024',
        //   link: 'https://x.com/DeepLinkGlobal/status/1799036124150821272',
        //   delay: 100,
        //   img_url: 'cont13_bg25.jpg'
        // },
        {
          title: "We held a meetup in Seoul today with ETNEWS, Korea's top IT news media",
          time: '14/06 2024',
          link: 'https://x.com/DeepBrainChain/status/1801600720757789162',
          delay: 200,
          img_url: 'cont13_bg24.jpg'
        },
        {
          title: 'DeepBrainChain attended the US Consensus Conference. We brought the first AI project',
          time: '01/06 2024',
          link: 'https://x.com/DeepBrainChain/status/1796677581502095490',
          delay: 300,
          img_url: 'cont13_bg23.jpg'
        },
        {
          title: "DBC founders and council members attended the BTC Consensus Conference in Austin",
          time: '30/05 2024',
          link: 'https://x.com/DeepBrainChain/status/1795996265492140187',
          delay: 200,
          img_url: 'cont13_bg22.jpg'
        },
        {
          title: 'DeepBrainChain participated in the 2024 Tokyo Blockchain Expo, one of the largest blockchain events in Japan. This exhibition brought together global elites from the AI and Blockchain industries.',
          time: '24/05 2024',
          link: 'https://x.com/DeepBrainChain/status/1793958508335120434',
          delay: 300,
          img_url: 'cont13_bg21.jpg'
        },
        {
          title: 'Introducing DeepBrainChain to crypto investors from multiple countries around the world at the token2049 conference',
          time: '19/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1781270973737816073',
          delay: 400,
          img_url: 'cont13_bg20.jpg'
        },

        {
          title: 'Arriving at the Dubai venue, the DBC&Deeplink booth is packed with people.',
          time: '18/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1780863389889364358',
          delay: 200,
          img_url: 'cont13_bg19.jpg'
        },
        {
          title: 'TeamZ Web3 Japan Summit ended successfully！',
          time: '14/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1779440009134919731',
          delay: 300,
          img_url: 'cont13_bg18.jpg'
        },
        {
          title: 'The DBC booth was crowded with people and was warmly welcomed by everyone.',
          time: '13/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1779152234875584607',
          delay: 400,
          img_url: 'cont13_bg17.jpg'
        },
        {
          title: 'Felix, a DBC director from Japan, is delivering a speech at the Global DePIN Hardware Conference.',
          time: '08/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1777276310571897256',
          delay: 300,
          img_url: 'cont13_bg16.jpg'
        },
        {
          title: 'DBC Ambassadors attended the DePIN China Tour Shenzhen Meetup',
          time: '05/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1776195577954607110',
          delay: 400,
          img_url: 'cont13_bg15.jpg'
        },
        {
          title: 'DBC Ambassador introduces #DeepBrainChain at Web3 Storage Conference hosted by Swarm #DBC #DeepBrainChain',
          time: '03/04 2024',
          link: 'https://x.com/DeepBrainChain/status/1775470361074868698',
          delay: 500,
          img_url: 'cont13_bg14.jpg'
        },
        {
          title: '🔥DeepBrainChain Meetup event is in progress at Amazon Hangzhou, China, Tongji University, ICP, and Llama China',
          time: '30/03 2024',
          link: 'https://x.com/DeepBrainChain/status/1773992128999473261',
          delay: 300,
          img_url: 'cont13_bg13.jpg'
        },
        {
          title: 'Electronic sports Hotel Group covers 27 cities in China and is a well-known esports hotel brand in China. Starting from this year, we will work together to provide them with DBC’s GPU computing power and DeepLink’s cloud esports ultra-low game rendering latency. solution',
          time: '18/03 2024',
          link: 'https://x.com/deepbrainfeng/status/1769573009768288765',
          delay: 400,
          img_url: 'cont13_bg12.jpg'
        },
        {
          title: 'The AI ​​cloud platform Hycons based on the DBC decentralized GPU network provides AI users with an unparalleled experience, and the GPU price saves more than 90% compared to AWS.',
          time: '07/03 2024',
          link: 'https://x.com/deepbrainfeng/status/1765532462351024216',
          delay: 500,
          img_url: 'cont13_bg11.jpg'
        },

        {
          title: 'Chengdu Internet Cafe Technical Conference in China',
          time: '04/03 2024',
          link: 'https://twitter.com/DeepBrainChain/status/1764676037366231365?t=LUmiOO3PWHX5Hca41pbXRw&s=19',
          delay: 500,
          img_url: 'cont13_bg10.jpg'
        },
        {
          title: 'DBC Blockchain Conference Video Review in Phuket, Thailand',
          time: '05/02 2024',
          link: 'https://twitter.com/DeepBrainChain/status/1754500650648715521?t=-pneye4mhfHfdZGjoZ5zXw&s=19',
          delay: 600,
          img_url: 'cont13_bg9.jpg'
        },
        {
          title: 'DeepBrainChain& #DeepLink&TIKEREN cloud gaming all-in-one strategic cooperation conference to jointly enter Japan',
          time: '20/12 2023',
          link: 'https://twitter.com/deepbrainfeng/status/1737496574278725733?t=3HftJUj9ee-3cEkjYnDr1w&s=19',
          delay: 700,
          img_url: 'cont13_bg8.png'
        },
        {
          title: 'Vietnam ESPORTS3.0 EVENT',
          time: '07/10 2023',
          link: 'https://twitter.com/DeepLinkVietNam/status/1710551891061756038',
          delay: 500,
          img_url: 'cont13_bg7.png'
        },
        {
          title: 'Vietnam MARVELS HCMC DeepBrain Chain',
          time: '08/06 2023',
          link: 'https://twitter.com/DeepBrainChain/status/1666651735266562052',
          delay: 600,
          img_url: 'cont13_bg6.png'
        },
        {
          title: 'DeepBrain Chain Hong Kong Events',
          time: '16/04 2023',
          link: 'https://twitter.com/deepbrainfeng/status/1647529443945226241?s=20',
          delay: 700,
          img_url: 'cont13_bg5.png'
        },
        {
          title: 'DeepBrain Chain Singapore Events',
          time: '17/01 2023',
          link: 'https://twitter.com/deepbrainfeng/status/1615370872252137473?s=20',
          delay: 800,
          img_url: 'cont13_bg4.png'
        },
        {
          title: 'DeepBrain Chain AI meets Blockchain in Stuttgart, Germany',
          time: '13/07 2018',
          link: 'https://twitter.com/onegamerocks/status/1017718325969899522',
          delay: 700,
          img_url: 'cont13_bg3.png'
        },
        {
          title: 'DeepBrain Chain participates CCF-GAIR in Shenzhen',
          time: '01/07 2018',
          link: 'https://twitter.com/DeepBrainChain/status/1013332400208670720',
          delay: 800,
          img_url: 'cont13_bg2.png'
        },
        {
          title: 'DeepBrain Chain Blockchain Connect Conference in San Francisco',
          time: '13/01 2018',
          link: 'https://twitter.com/coindar_/status/951993629576454144',
          delay: 900,
          img_url: 'cont13_bg1.jpg'
        }
      ])
      const linkHerf = (str) => {
        window.open(str)
      }

      
      const copyFallback = (text) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        const success = document.execCommand('copy');
        document.body.removeChild(textArea);
        return success;
      };

      const copyClipboard = async (text) => {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (err) {
          // 降级方案
          return copyFallback(text);
        }
      }

      const scrollbarRef = ref()

      const medialist  = ref([
        {
          new_title: "BlockBeats",
          link: "https://www.theblockbeats.info/news/56089",
          text: "ChatGPT两周年，去中心化AI的机遇何在？深脑链DBC给出了答案",
          date: "24-12-08",
          img: "new10.webp",
        },
        {
          new_title: "HackerNoon",
          link: "https://hackernoon.com/the-synergy-of-ai-and-blockchain-how-deepbrain-chain-globally-democratizes-gpu-ai-infrastructure",
          text: "The Synergy of AI and Blockchain: How DeepBrain Chain Globally Democratizes GPU AI Infrastructure",
          date: "August 13th, 2024",
          img: "new9.avif",
        },
        {
          new_title: "Yahoo",
          link: "https://finance.yahoo.com/news/deepbrain-chain-leads-charge-embracing-163500805.html",
          text: "DeepBrain Chain Leads the Charge in Embracing the DePIN Revolution with Rising AI and Web3 Integration Demand",
          date: "Sat, Mar 30, 2024",
          img: "cont12_img1.png",
        },
        {
          new_title: "Chain Catcher",
          link: "https://www.chaincatcher.com/article/2117966",
          text: "AI 与 Web3 在元宇宙风云际会，DePIN 准备好了吗？",
          date: "2024年03月21日",
          img: "new8.jpg",
        },
        {
          new_title: "InvestorsObserver",
          link: "https://www.investorsobserver.com/news/crypto-update/should-you-buy-deepbrain-chain-dbc-saturday",
          text: "Should You Buy DeepBrain Chain (DBC) Saturday?",
          date: "January 27, 2024",
          img: "new5.jpg",
        },
        {
          new_title: "OvenAdd",
          link: "https://ovenadd.com/deepbrain-chain-dbc-price-prediction/",
          text: "DeepBrain Chain (DBC) Price Prediction 2024, 2025, 2030, 2035 | Will DBC Rise?",
          date: "December 2, 2023",
          img: "new7.jpg",
        },
        {
          new_title: "Brave NewCoin",
          link: "https://bravenewcoin.com/insights/the-top-10-ai-cryptocurrencies",
          text: "The Top 10 AI Cryptocurrencies: Up 157% in 2023",
          date: "21 Sep 2023",
          img: "cont12_img1.png",
        },
        {
          new_title: "BlockChain Today",
          link: "https://blog.naver.com/blockchaintoday/223153153609",
          text: "DeepBrain Chain, GPU 클라우드 컴퓨팅으로 '클라우드 컴퓨팅 혁신' 실현 [출처] DeepBrain Chain, GPU 클라우드 컴퓨팅으로 '클라우드 컴퓨팅 혁신' 실현|작성자 블록체인투데이",
          date: "2023. 7. 11",
          img: "new4.jpg",
        },
        {
          new_title: "Altcoin Buzz",
          link: "https://www.altcoinbuzz.io/reviews/top-3-most-profitable-ai-coins-according-to-chatgpt/",
          text: "Top 3 Most Profitable AI Coins According to ChatGPT",
          date: "June 13, 2023",
          img: "cont12_img1.png",
        },
        {
          new_title: "청년투자자 정현",
          link: "https://blog.naver.com/zigyt/223059848282",
          text: "인공지능 AI 관련코인 AGIX, FET 가격, 전망 확인해봐요",
          date: "2023.3.30",
          img: "new6.png",
        },
        {
          new_title: "Binance Square",
          link: "https://www.binance.com/en/feed/post/255516",
          text: "Huawei Cloud Announces Launch of Metaverse and Web3 Alliance",
          date: "Feb 27, 2023",
          img: "cont12_img4.png",
        },
        {
          new_title: "Coin Edition",
          link: "https://coinedition.com/huawei-cloud-and-tencent-cloud-announce-web3-alliances/",
          text: "Huawei Cloud and Tencent Cloud Announce Web3 Alliances",
          date: "Feb 27, 2023",
          img: "cont12_img5.png",
        },
        {
          new_title: "CoinSpeaker",
          link: "https://www.coinspeaker.com/huawei-cloud-metaverse-web3-blockchain/",
          text: "Huawei Cloud Launches Metaverse and Web3 Initiative to Foster Blockchain Adoption in Asian Region",
          date: "Feb 27, 2023",
          img: "cont12_img4.png",
        },
        {
          new_title: "WeiXin",
          link: "https://mp.weixin.qq.com/s/0qcXdqJGzMMLHgdzYz5z-w",
          text: "华为云发起元宇宙 & Web3.0联盟，风口上的 AI 计算平台Deepbrain Chain再次登台亮相",
          date: "2023年02月25日",
          img: "comp3.jpg",
        },
        {
          new_title: "Cryptotvplus",
          link: "https://cryptotvplus.com/2023/02/all-you-need-to-know-about-deepbrain-chain/",
          text: "All you need to know about DeepBrain chain?",
          date: "February 6, 2023",
          img: "new2.jpg",
        },
        {
          new_title: "Yahoo",
          link: "https://finance.yahoo.com/news/deepbrain-chain-computing-power-mainnet-115100106.html?guccounter=1",
          text: "DeepBrain Chain Computing Power Mainnet Launches Online, Meaning All GPU Servers Can Now Freely Connect to the DBC Network, All Information Available On-Chain",
          date: "December 17, 2021",
          img: "new5.webp",
        },
        {
          new_title: "AP News",
          link: "https://apnews.com/press-release/marketersmedia/technology-blockchain-artificial-intelligence-5baa7937549a0f02b1cb0612f9afefa5",
          text: "DeepBrain Chain computing power mainnet launches online, meaning all GPU servers can now freely connect to the DBC network",
          date: "December 17, 2021",
          img: "cont12_img7.png",
        },
        {
          new_title: "36KR",
          link: "https://36kr.com/p/1253772390861320",
          text: "一文读懂深脑链DBC：无限扩容的分布式高性能算力网络",
          date: "2021-06-04",
          img: "cont12_img3.png",
        },
      ])

      const showimg = ref('new10.webp')
      const chooseIndex = ref(0)
      const chooseMedia = async (el, index) => {
        showimg.value = el.img
        chooseIndex.value = index
      }

      const linkHref2 = (command) => {
        router.push({path: command})
        localStorage.setItem('path', command)
        store.commit('changePath', command)
      }

      onMounted(async () => {
        scrollbarRef.value.setScrollLeft(2000)
        await getNumber()
        window.addEventListener('scroll', handleScroll1)
        window.addEventListener('visibilitychange', visibilityChange)
      });
      onBeforeUnmount(() => {
        ball_show.value = false
        window.removeEventListener('scroll', handleScroll1)
        window.removeEventListener('visibilitychange', visibilityChange)
      });
      return {
        lan,
        seeVideo,
        linkHerf,
        totalNum,
        YTBShow,
        Number_inc,
        count_start1,
        count_start2,
        count_start3,
        count_start4,
        count_start5,
        count_start6,
        count_start7,
        count_start8,
        handleScroll,
        ball_show,
        handleScroll1,
        eventInfo,
        copyClipboard,
        scrollbarRef,

        medialist,
        showimg,
        chooseIndex,
        chooseMedia,
        linkHref2
      };
    }
  })
</script>

<style lang="scss" scoped>
// DeepBrainChain 3.0 预告横幅样式
.dbc3_announcement {
  position: relative;
  width: 100%;
  min-height: 500px;
  padding: 80px 0;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a1a 0%, #1a0a2e 30%, #0f1629 70%, #0a0a1a 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  // 背景粒子
  .dbc3_bg_particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .particle {
      position: absolute;
      width: 4px;
      height: 4px;
      background: rgba(114, 28, 255, 0.6);
      border-radius: 50%;
      animation: float 15s infinite;
      @for $i from 1 through 20 {
        &:nth-child(#{$i}) {
          left: random(100) * 1%;
          top: random(100) * 1%;
          animation-delay: -#{random(15)}s;
          animation-duration: #{10 + random(10)}s;
        }
      }
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0) translateX(0);
      opacity: 0;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      transform: translateY(-100vh) translateX(50px);
      opacity: 0;
    }
  }

  // 发光效果
  .dbc3_glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(114, 28, 255, 0.3) 0%, rgba(54, 255, 207, 0.1) 40%, transparent 70%);
    filter: blur(60px);
    animation: pulse 4s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.6;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.2);
      opacity: 1;
    }
  }

  // 内容区域
  .dbc3_content {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 900px;
    padding: 0 40px;
  }

  // COMING SOON 徽章
  .dbc3_badge {
    display: inline-block;
    padding: 8px 24px;
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 3px;
    color: #36FFCF;
    border: 1px solid rgba(54, 255, 207, 0.5);
    border-radius: 30px;
    background: rgba(54, 255, 207, 0.1);
    animation: badgePulse 2s ease-in-out infinite;
  }

  @keyframes badgePulse {
    0%, 100% {
      box-shadow: 0 0 20px rgba(54, 255, 207, 0.3);
    }
    50% {
      box-shadow: 0 0 40px rgba(54, 255, 207, 0.6);
    }
  }

  // 主标题
  .dbc3_title {
    margin-bottom: 15px;
    .dbc3_text_gradient {
      font-size: 72px;
      font-weight: 700;
      background: linear-gradient(90deg, #36FFCF 0%, #438EFF 50%, #721CFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      animation: gradientShift 3s ease-in-out infinite;
      background-size: 200% auto;
    }
  }

  @keyframes gradientShift {
    0%, 100% {
      background-position: 0% center;
    }
    50% {
      background-position: 100% center;
    }
  }

  // 副标题
  .dbc3_tagline {
    font-size: 28px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 40px;
    letter-spacing: 2px;
  }

  // 神秘功能列表
  .dbc3_mystery {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 40px;
    flex-wrap: wrap;

    .mystery_item {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 15px 25px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(114, 28, 255, 0.2);
        border-color: rgba(114, 28, 255, 0.5);
        transform: translateY(-3px);

        .mystery_icon {
          animation: shake 0.5s ease-in-out;
        }
      }

      .mystery_icon {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        font-weight: 700;
        color: #721CFF;
        background: rgba(114, 28, 255, 0.2);
        border-radius: 50%;
      }

      .mystery_text {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  @keyframes shake {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-10deg); }
    75% { transform: rotate(10deg); }
  }

  // 悬念文字
  .dbc3_teaser {
    margin-bottom: 40px;

    .teaser_text {
      font-size: 22px;
      color: rgba(255, 255, 255, 0.7);
      margin-bottom: 10px;
      font-style: italic;
    }

    .teaser_subtext {
      font-size: 18px;
      color: #36FFCF;
      animation: blink 1.5s ease-in-out infinite;
    }
  }

  @keyframes blink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  // CTA 按钮
  .dbc3_cta {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 30px;

    .cta_btn {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      padding: 16px 32px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 12px;
      text-decoration: none;
      transition: all 0.3s ease;
      cursor: pointer;

      &.primary {
        color: #000;
        background: linear-gradient(90deg, #36FFCF 0%, #438EFF 100%);

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(54, 255, 207, 0.4);
        }

        .btn_arrow {
          transition: transform 0.3s ease;
        }

        &:hover .btn_arrow {
          transform: translateX(5px);
        }
      }

      &.secondary {
        color: #fff;
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.3);

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          border-color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }

  // 标签
  .dbc3_hints {
    display: flex;
    justify-content: center;
    gap: 15px;
    flex-wrap: wrap;

    .hint_tag {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.5);
      transition: color 0.3s ease;

      &:hover {
        color: #36FFCF;
      }
    }
  }
}

.home {
  min-width: 1200px;
  margin: auto;
  font-style: normal;
  // font-family: "Noto Sans SC";
  .cont_title {
    color: #fff;
    font-size: 48px;
    font-weight: 500;
    text-align: center;
    line-height: normal;
    margin-bottom: 10px;
    letter-spacing: 0.96px;
  }
  .cont_desc {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px; 
    text-align: center;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.6);
  }
  .point_list {
    gap: 8px;
    display: inline-flex;
    align-items: center;
    .point {
      width: 12px;
      height: 12px;
      border-radius: 12px;
      &.point1 {
        background: #06FFB0;
      }
      &.point2 {
        background: #7300FF;
      }
    }
  }
  @keyframes upDown {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-60px);
    }
  }
  .content1 {
    width: 1200px;
    margin: auto;
    height: 100vh;
    min-height: 920px;
    display: flex;
    align-items: center;
    .banner_content {
      width: 100%;
      height: 920px;
      overflow: hidden;
      position: relative;
      .content1_bg1 {
        position: absolute;
        right: 0;
        top: 90px;
        height: 800px;
        width: 700px;
        .banner {
          margin-top: 50px;
          width: 694px;
          height: 515px;
          animation: upDown 3s ease-in-out infinite;
        }
        .base {
          width: 1167px;
          position: absolute;
          bottom: 0;
          right: -220px;
        }
      }
      .introduce {
        position: absolute;
        bottom: 140px;
        z-index: 1;
        .text1 {
          color: #FFF;
          font-size: 80px;
          font-weight: 300;
          line-height: normal;
          letter-spacing: 1.6px;
        }
        .text2 {
          color: #FFF;
          font-size: 80px;
          font-weight: 600;
          letter-spacing: 1.6px;
        }
        .text3 {
          font-size: 36px;
          margin-top: 24px;
          padding: 14px 38px;
          border-radius: 22px;
          display: inline-block;
          box-sizing: border-box;
          color: rgba(255, 255, 255, 0.6);
          background: rgba(255, 255, 255, 0.05);
          border: 2px solid rgba(255, 255, 255, 0.15);
        }
      }
      .line {
        width: 17px;
        height: 80px;
        margin: 30px 10px;
        background: url(../assets/home/line.png) no-repeat;
        background-size: 9px 80px;
      }
      .detailed {
        width: 560px;
        font-size: 16px;
        color: #899AA9;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 1px;
        margin-bottom: 12px;
      }
    }
  }
  .top_info {
    margin: auto;
    width: 1200px;
    display: flex;
    margin-bottom: 5px;
    align-items: flex-end;
    justify-content: space-between;
  }
  .dbc_intro {
    width: 1200px;
    margin: 88px auto 150px;
    .top_info {
      margin-bottom: 33px;
      .dbc_logo {
        font-size: 16px;
        padding: 10px 20px;
        border-radius: 17px;
        align-items: center;
        display: inline-flex;
        box-sizing: border-box;
        color: rgba(255, 255, 255, 1);
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(253, 253, 253, 0.1);
        .img {
          width: 45px;
          height: 40px;
          margin-left: 120px;
          background: url(../assets/new_home/icon.png) no-repeat 100%/100%;
        }
      }
    }
    .intro_text {
      color: #fff;
      font-size: 16px;
      line-height: 29px;
      margin-bottom: 33px;
    }
    .intro_btn {
      display: inline-flex;
      align-items: center;
      color: #000;
      font-size: 16px;
      padding: 16px 32px;
      background: #fff;
      border-radius: 16px;
      .arrow {
        margin-left: 70px;
        display: inline-block;
      }
    }
  }
  .meme_intro {
    width: 1200px;
    margin: 88px auto 150px;
    .meme_title {
      color: #fff;
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .intro_text {
      font-size: 16px;
      line-height: 29px;
      margin-bottom: 33px;
      color: rgba(253, 253, 253, 0.6);
    }
    .contract {
      display: flex;
      align-items: center;
      .contract_text {
        font-size: 24px;
        line-height: 54px;
        margin-right: 10px;
        color: rgba(253, 253, 253, 0.6);
      }
      .contract_address {
        display: flex;
        color: #fff;
        padding: 10px 20px;
        align-items: center;
        border-radius: 11px;
        background: #721CFF;
        box-sizing: border-box;
        .icon {
          display: flex;
          width: 24px;
          height: 24px;
          cursor: pointer;
          margin-left: 10px;
          background: url(../assets/new_home/copy.png) no-repeat 100%/100%;
        }
      }
    }
  }
  .content2 {
    width: 100%;
    height: 660px;
    padding-top: 120px;
    background: #ECDCFF;
    box-sizing: border-box;
    .cont_swap {
      margin: auto;
      width: 1200px;
      height: 646px;
      overflow: hidden;
      background: url(../assets/new_home/cont2_bg.png) no-repeat 100%/100%;
      .carousel {
        width: 1100px;
        margin: auto;
        .sliper {
          display: flex;
          width: 100%;
          height: 646px;
          padding: 0 60px;
          align-items: center;
          box-sizing: border-box;
          justify-content: space-between;
          .sliper_left {
            width: 540px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            .sliper_text {
              color: #fff;
              font-size: 36px;
              font-weight: 500;
              line-height: normal;
              // margin-bottom: 10px;
              letter-spacing: 0.96px;
            }
            .sliper_text1 {
              color: #fff;
              font-size: 80px;
              font-weight: 500;
              line-height: normal;
              margin-bottom: 10px;
              letter-spacing: 0.96px;
            }
            .sliper_btn {
              // margin: auto;
              color: #FFF;
              cursor: pointer;
              font-size: 16px;
              font-weight: 500;
              margin-top: 60px;
              padding: 10px 60px;
              line-height: normal;
              transition: all .5s;
              text-decoration: none;
              background: #41A4FF;
              margin-right: 50px;
              &:hover {
                background: #0989FF;
              }
            }
          }
          .sliper_right {
            width: 500px;
            img {
              width: 500px;
              &.marginL {
                margin-left: 60px;
              }
            }
          }
        }
      }
    }
  }
  .content3 {
    width: 100%;
    margin-top: 200px;
    padding: 80px 0 40px;
    box-sizing: border-box;
    .cont3_title {
      margin: auto;
      width: 1200px;
      color: #fff;
      font-size: 48px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    .cont3_desc {
      margin: auto;
      width: 1200px;
      font-size: 16px;
      line-height: 29px;
      margin-bottom: 33px;
      color: rgba(253, 253, 253, 0.6);
    }
    .cont3_swap {
      width: 1200px;
      margin: 0 auto 20px;
      .ecologyList {
        gap: 25px;
        display: flex;
        width: fit-content;
        margin-bottom: 20px;
        .ecologyLi {
          flex-shrink: 0;
          width: 430px; 
          padding: 50px;
          border-radius: 35px;
          box-sizing: border-box;
          border: 1px solid rgba(255, 255, 255, 0.12);
          // border: 2px solid #FFF;
          // backdrop-filter: blur(12.5px);
          // transition: all 1s;
          // box-shadow: 0px 4px 49px 0px rgba(0, 7, 72, 0.12);
          // background: linear-gradient(155deg, rgba(255, 255, 255, 0.00) -2.13%, rgba(255, 255, 255, 0.15) 136.58%);
          .ecolog_top {
            width: 100%;
            display: flex;
            margin-bottom: 96px;
            align-items: flex-end;
            justify-content: space-between;
            .logo_img {
              width: 146px;
              height: 146px;
            }
            .link_img {
              width: 85px;
              height: 85px;
              background: url(../assets/new_home/arrow.png) no-repeat 100%/100%;
              &:hover {
                background: url(../assets/new_home/arrow1.png) no-repeat 100%/100%;
              }
            }
          }
          .ecology_title {
            color: #FFF;
            font-size: 36px;
            font-weight: 600;
            margin-bottom: 15px;
            line-height: normal;
          }
          .ecology_text {
            font-size: 16px;
            line-height: 24px;
            color: rgba(255, 255, 255, 0.6);
          }
        }
      }
    }
  }
  .unifycontent {
    width: 100%;
    overflow: hidden;
    position: relative;
    background: url(../assets/new_home/cont4_bg.png) repeat;
    .content4 {
      position: relative;
      z-index: 1;
      width: 1200px;
      margin: auto;
      padding: 140px 0;
      box-sizing: border-box;
      .cont4_title {
        margin: auto;
        width: 1200px;
        color: #000;
        font-size: 48px;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .cont4_desc {
        margin: auto;
        width: 1200px;
        font-size: 16px;
        line-height: 29px;
        margin-bottom: 33px;
        color: rgba(0, 0, 0, 0.6);
      }
      .numberList {
        margin-top: 80px;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        align-items: center;
        justify-content: center;
        .number_block {
          padding: 57px 0;
          box-sizing: border-box;
          border-top: 1px solid #9A9A9A;
          border-right: 1px solid #9A9A9A;
          border-bottom: 1px solid #9A9A9A;
          &.w25 {
            width: 25%;
          }
          &.w33 {
            width: 33.33%;
            border-top: 0px;
          }
          &.w50 {
            width: 50%;
            border-top: 0px;
            border-radius: 0 0 20px 20px;
            border-left: 1px solid #9A9A9A;
          }
          &:nth-child(4) {
            border-right: 0px;
          }
          &:nth-child(7) { 
            border-right: 0px;
          }
          .number {
            color: #000;
            font-size: 48px;
            font-weight: 600;
            line-height: 50px;
            margin-bottom: 10px;
          }
          .num_desc {
            height: 48px;
            font-size: 20px;
            line-height: 24px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
        
      }
    }
    .content5 {
      position: relative;
      z-index: 1;
      width: 1200px;
      display: flex;
      margin: 0 auto;
      padding: 80px 0 100px;
      box-sizing: border-box;
      justify-content: space-between;
      .left {
        width: 320px;
        margin-right: 100px;
        .title {
          color: #000;
          font-size: 64px;
          font-weight: 600;
          margin-bottom: 10px;
          line-height: normal;
          letter-spacing: 0.96px;
        }
        .text {
          font-size: 16px;
          color: #899AA9;
          font-weight: 400;
          line-height: 24px;
          letter-spacing: 1px;
        }
      }
      .right {
        flex: 1;
        // height: 480px;
        display: flex;
        justify-content: space-between;
        .list {
          width: 380px;
          display: flex;
          flex-direction: column;
          &:last-child {
            margin-top: 100px;
          }
          .listInfo {
            width: 100%;
            padding: 30px;
            margin-bottom: 50px;
            border-radius: 35px;
            box-sizing: border-box;
            border: 5px solid #eedffe;
            background: rgba(0, 0, 0, 0.1);
            .top_img {
              height: 44px;
              display: flex;
              justify-content: flex-end;
            }
            .text1 {
              color: #000;
              font-size: 30px;
              font-weight: 600;
              line-height: 32px;
              margin: 20px 0 30px;
            }
            .text2 {
              font-size: 20px;
              line-height: 24px;
              color: rgba(0, 0, 0, 0.6);
            }
          }
        }
      }
    }
  }
  .content6 {
    z-index: 1;
    width: 1200px;
    margin: 0 auto 190px;
    box-sizing: border-box;
    .cont6_con {
      position: relative;
      display: flex;
      align-items: center;
      .left {
        flex: 1;
        padding: 140px 0 200px;
        .cont6_title {
          color: #fff;
          font-size: 48px;
          font-weight: 600;
          margin-bottom: 100px;
        }
        .token_text {
          display: flex;
          font-size: 16px;
          font-weight: 400;
          line-height: 24px;
          margin-bottom: 30px;
          justify-content: space-between;
          color: rgba(255, 255, 255, 0.6);
          .icon {
            width: 14px;
            height: 14px;
            margin-right: 12px;
            border-radius: 14px;
            background: #924EFF;
          }
          p {
            flex: 1;
          }
        }
      }
      .right {
        position: sticky;
        top: 100px;
        width: 460px;
        display: flex;
        align-items: center;
        flex-direction: column;
        .right_bg {
          height: 50vh;
          // height: 50%;
          width: 340px;
          margin-bottom: -230px;
          background: linear-gradient(rgba(129, 51, 255, 0) 0%, rgba(129, 51, 255, .3) 100%);
        }
        img {
          width: 460px;
          height: 460px;
          // position: absolute;
          // bottom: -60px;
        }
      }
    }
    
    .token_list {
      width: 100%;
      display: flex;
      margin-top: 65px;
      justify-content: space-between;
      .token_li {
        width: 385px;
        @keyframes glowing {
          0% {
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, #36FFCF, #36FFCF, #36FFCF, #438EFF) 1;
          }
          20% {
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, #438EFF, #36FFCF, #36FFCF, #36FFCF) 1;
          }
          40% {
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, #36FFCF, #438EFF, #36FFCF, #36FFCF) 1;
          }
          60% {
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, #36FFCF, #36FFCF, #438EFF, #36FFCF) 1;
          }
          100% {
            border-bottom: 2px solid;
            border-image: linear-gradient(to right, #36FFCF, #36FFCF, #36FFCF, #438EFF) 1;
          }
        }
        .token_block {
          padding: 24px;
          display: flex;
          margin-bottom: 25px;
          flex-direction: column;
          box-sizing: border-box;
          background: #10132F;
          position: relative;
          border-bottom: 2px solid #36FFCF;
          &:hover {
            animation: glowing 1s infinite;
          }
          .token_text {
            display: flex;
            font-size: 16px;
            color: #899AA9;
            font-weight: 400;
            line-height: 24px;
            margin-bottom: 10px;
            justify-content: space-between;
            .icon {
              width: 12px;
              height: 12px;
              margin-top: 6px;
              background: url(../assets/home/cont5_icon.png) 100%/100% no-repeat;
            }
            p {
              width: 310px;
            }
          }
          .token_icon1 {
            width: 200px;
            height: 200px;
            background: url(../assets/home/cont5_img1.png) 100%/100% no-repeat;
          }
          .token_icon2 {
            width: 141px;
            height: 140px;
            background: url(../assets/home/cont5_img2.png) 100%/100% no-repeat;
          }
        }
        .height1 {
          height: 336px;
        }
        .height2 {
          height: 188px;
        }
        .height3 {
          height: 232px;
        }
        .height4 {
          height: 292px;
        }
        .height5 {
          height: 192px;
        }
        .height6 {
          height: 332px;
        }
        
      }
    }
  }
  .content7 {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0 100px;
    box-sizing: border-box;
    
    @keyframes LeftR {
      0%, 100% {
        transform: translateX(0);
      }
      50% {
        transform: translateX(-30px);
      }
    }
    @keyframes RightL {
      0%, 100% {
        transform: translateX(-20px);
      }
      50% {
        transform: translateX(0);
      }
    }
    @keyframes UpD {
      0%, 100% {
        transform: translateY(-20px);
      }
      50% {
        transform: translateY(0);
      }
    }
    @keyframes DownU {
      0%, 100% {
        transform: translateY(-20px);
      }
      50% {
        transform: translateY(0);
      }
    }
    .bg1 {
      animation: LeftR 2s ease-in-out infinite;
      position: absolute;
      top: 250px;
      left: 100px;
      width: 150px;
      height: 153px;
      background: url(../assets/new_home/cont7_bg1.png) no-repeat 100%/100%;
    }
    .bg2 {
      animation: UpD 2s ease-in-out infinite;
      position: absolute;
      top: 510px;
      left: 400px;
      width: 118px;
      height: 120px;
      background: url(../assets/new_home/cont7_bg2.png) no-repeat 100%/100%;
    }
    .bg3 {
      animation: DownU 2s ease-in-out infinite;
      position: absolute;
      top: 300px;
      right: 400px;
      width: 150px;
      height: 153px;
      background: url(../assets/new_home/cont7_bg3.png) no-repeat 100%/100%;
    }
    .bg4 {
      animation: RightL 2s ease-in-out infinite;
      position: absolute;
      top: 200px;
      right: 100px;
      width: 184px;
      height: 187px;
      background: url(../assets/new_home/cont7_bg4.png) no-repeat 100%/100%;
    }
    .exchange {
      position: relative;
      z-index: 10;
      width: 100%;
      display: flex;
      align-items: center;
      margin: 240px 0 160px;
      justify-content: space-around;
      .exchange_li {
        height: 102px;
        display: flex;
        padding: 0 38px;
        align-items: center;
        border-radius: 21px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        img {
          height: 43px;
          cursor: pointer;
        }
        img.mexc {
          height: 26px;
        }
      }
    }
    .contract {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      justify-content: center;
      .contract_text {
        font-size: 24px;
        line-height: 54px;
        margin-right: 10px;
        color: rgba(253, 253, 253, 0.6);
      }
      .contract_address {
        display: flex;
        color: #fff;
        padding: 10px 20px;
        align-items: center;
        border-radius: 11px;
        background: #721CFF;
        box-sizing: border-box;
        .icon {
          display: flex;
          width: 24px;
          height: 24px;
          cursor: pointer;
          margin-left: 10px;
          background: url(../assets/new_home/copy.png) no-repeat 100%/100%;
        }
      }
    }
    .contract_token {
      gap: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .token_test {
        color: rgba(255, 255, 255, 0.6);
        span {
          color: #fff;
          font-weight: 600;
        }
      }
    }
    // .contract_add {
    //   font-size: 16px;
    //   font-weight: 400;
    //   color: #899AA9;
    //   line-height: 24px;
    //   text-align: center;
    //   letter-spacing: 1px;
    //   margin-bottom: 15px;
    // }
    // .contract_address {
    //   font-size: 32px;
    //   font-weight: 400;
    //   color: transparent;
    //   text-align: center;
    //   letter-spacing: 1px;
    //   background-clip: text;
    //   -webkit-background-clip: text;
    //   -webkit-text-fill-color: transparent;
    //   background-image: linear-gradient(90deg, #36FFCF -3.33%, #438EFF 100%);
    // }
  }
  .content8 {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0 100px;
    box-sizing: border-box;
    .cont_table {
      width: 100%;
      padding: 24px;
      margin-top: 40px;
      box-sizing: border-box;
      .table_cont {
        width: 100%;
        color: #fff;
        font-size: 18px;
        font-weight: 400;
        line-height: 150%;
        text-align: left;
        border-collapse: collapse;
        tr.theader {
          background: #721CFF;
          th {
            border: none;
            padding: 10px;
          }
        }
        tr.tfooter {
          background: rgba(114, 28, 255, 0.2);
        }
        th {
          padding: 0 20px;
        }
        td {
          padding: 10px 10px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        }
        .font16 {
          font-size: 16px;
          font-weight: 400;
          color: #fff;
          line-height: 150%;
        }
        // .color1 {
        //   color: #38EED6;
        // }
        // .color2 {
        //   color: #41A4FF;
        // }
        .width60 {
          width: 60px;
          box-sizing: border-box;
        }
        .width210 {
          width: 210px;
        }
        .width240 {
          width: 240px;
        }
      }
    }
  }
  .content9 {
    background: rgba(255, 255, 255, 0.03);
    .cont9_con {
      position: relative;
      z-index: 1;
      width: 1200px;
      margin: 0 auto;
      padding: 200px 0 200px;
      box-sizing: border-box;
      // background: rgba(255, 255, 255, 0.03);
      .partner {
        gap: 24px;
        width: 1100px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin: 100px auto 0;
        justify-content: center;
        .partner_li {
          height: 102px;
          display: flex;
          padding: 0 38px;
          align-items: center;
          border-radius: 21px;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          img {
            height: 50px;
          }
        }
      }
    }
  }
  .content10 {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0 0;
    box-sizing: border-box;
    .timeLine {
      width: 100%;
      // height: 456px;
      margin: 40px 0;
      overflow: hidden;
      .time_cont {
        width: 1200px;
        display: flex;
        justify-content: space-between;
        &.text_right {
          text-align: right;
        }
        .time_blank {
          width: 536px;
        }
        .time_content {
          width: 536px;
          display: flex;
          line-height: 150%;
          flex-direction: column;
          .time_cont_title {
            color: #fff;
            font-size: 24px;
            font-weight: 700;
            margin-top: 18px;
          }
          .time_cont_text {
            font-size: 16px;
            color: rgba(255, 255, 255, .7);
            font-weight: 500;
            margin-top: 10px;
            a {
              color: #fff;
            }
          }
        }
        .time_num {
          width: 80px;
          display: flex;
          align-items: center;
          flex-direction: column;
          p {
            color: rgba(255, 255, 255, 0.8);
            font-size: 40px;
            font-weight: 900;
            line-height: 150%; 
          }
          .time_line {
            width: 2px;
            margin-top: 5px;
            height: -webkit-fill-available;
            background: linear-gradient(180deg, #36FFCF -3.33%, #438EFF 100%);
          }
        }
      }
    }
    
  }
  .content11 {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto 125px;
    padding: 120px 0 200px;
    box-sizing: border-box;
    .top_info {
      align-items: center;
      justify-content: end;
      margin-bottom: 100px;
      .cont11_title {
        margin: auto;
        width: 1200px;
        color: #fff;
        font-size: 48px;
        font-weight: 600;
      }
    }
    .cont11_con {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      border-radius: 14px;
      justify-content: space-between;
      .roadmap {
        opacity: .5;
        padding: 40px;
        overflow: hidden;
        position: relative;
        transition: all 1s;
        box-sizing: border-box;
        border-radius: 14px 14px 0 0;
        border-bottom: 3px solid rgba(255, 255, 255, 0.1);
        a{
          color: #03FFB8;
          text-decoration: none;
        }
        &:hover{
          opacity: 1;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          border-left: 1px solid rgba(255, 255, 255, 0.1);
          border-right: 1px solid rgba(255, 255, 255, 0.1);
          border-bottom: transparent;
          &::after {
            content: '';
            position: absolute;
            bottom: 0px;
            left: 50%;
            width: 100%;
            height: 3px;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.1) 0%, #9525FF 46%, rgba(255, 255, 255, 0.1) 100%);
            transition: all 0.3s ease;
            transform: translateX(-50%);
          }
        }
      }
      .w33 {
        width: 33.33%;
      }
      .w50 {
        width: 50%;
        &:hover{
          border-top: transparent;
        }
      }
      .w100 {
        width: 100%;
        &:hover{
          border-top: transparent;
        }
      }
      .num {
        font-size: 40px;
        font-weight: 600;
        color: #fff;
        margin-bottom: 14px;
      }
      .desc {
        font-size: 20px;
        line-height: 30px;
        color: rgba(255, 255, 255, .6);
      }
    }
  }
  .content12 {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto 125px;
    padding: 120px 0 200px;
    box-sizing: border-box;
    .top_info {
      align-items: center;
      justify-content: end;
      margin-bottom: 100px;
      .cont12_title {
        margin: auto;
        width: 1200px;
        color: #fff;
        font-size: 48px;
        font-weight: 600;
      }
    }
    .cont12_con {
      display: flex;
      .left {
        width:  580px;
        height: 844px;
        border-radius: 26px;
        display: flex; /* 设置为flex布局 */
        justify-content: center; /* 水平居中对齐 */
        align-items: center; /* 垂直居中对齐 */
        overflow: hidden;
        margin-right: 70px;
        img {
          height: 844px;
        }
      }
      .right {
        flex: 1;
        position: relative;
        .cont12_list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .cont12_li {
            opacity: .4;
            padding: 50px;
            cursor: pointer;
            transition: all .5s;
            margin-bottom: 25px;
            border-radius: 26px;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.1);
            &.active {
              opacity: 1;
            }
            &:hover {
              opacity: 1;
            }
            &:last-child {
              margin-bottom: 0;
            }
            .news_title {
              font-size: 20px;
              line-height: 33px;
              margin-bottom: 10px;
              color: transparent;
              width: max-content;
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #7300FF -3.33%, #06FFB0 100%);
            }
            .text {
              color: #fff;
              font-size: 24px;
              font-weight: 600;
              line-height: 33px;
              margin-bottom: 15px;
            }
            .date {
              display: flex;
              font-size: 20px;
              line-height: 33px;
              align-items: center;
              justify-content: space-between;
              color: rgba(255, 255, 255, 0.6);
              .icon {
                display: flex;
                width: 44px;
                height: 44px;
                background: url(../assets/new_home/arrow.png) no-repeat 100%/100%;
                &:hover {
                  background: url(../assets/new_home/arrow1.png) no-repeat 100%/100%;
                }
              }
            }
          }
        }
      }
    }
    
  }
  .content13 {
    position: relative;
    z-index: 1;
    width: 1200px;
    height: 1060px;
    overflow: hidden;
    margin: 0 auto;
    padding: 80px 0 100px;
    box-sizing: border-box;
    .top_info {
      align-items: center;
      justify-content: end;
      margin-bottom: 100px;
      .cont13_title {
        margin: auto;
        width: 1200px;
        color: #fff;
        font-size: 48px;
        font-weight: 600;
      }
    }
    .cont13_cont {
      width: 600px;
      padding: 30px;
      border-radius: 50px;
      box-sizing: border-box;
      background: #060607;
      border: 8px solid rgba(255, 255, 255, 0.1);
      .active_img {
        width: 540px;
        height: 540px;
        border-radius: 36px;
        display: flex; /* 设置为flex布局 */
        justify-content: center; /* 水平居中对齐 */
        align-items: center; /* 垂直居中对齐 */
        overflow: hidden;
        img {
          object-fit: cover;
        }
      }
      .title {
        height: 52px;
        color: #fff;
        font-size: 20px;
        font-weight: 600;
        margin: 20px 0 10px;
        overflow: hidden; /* 超出部分将被隐藏 */
        display: -webkit-box; /* 必需的WebKit前缀 */
        -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
        -webkit-box-orient: vertical; 
      }
      .text {
        font-size: 20px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .event_list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-top: 60px;
      justify-content: space-between;
      .event_li {
        width: 370px;
        .event_cont {
          width: 370px;
          height: 280px;
          padding: 8px;
          display: flex;
          overflow: hidden;
          align-items: center;
          margin-bottom: 12px;
          border: 2px solid;
          box-sizing: border-box;
          justify-content: center;
          border-image: linear-gradient(to right, #36FFCF, #438EFF) 1;
          img {
            width: 350px;
            height: 260px;
            object-fit: cover;
          }
        }
        .img_cont {
          width: 100%;
          display: flex;
          color: #fff;
          cursor: pointer;
          margin-bottom: 20px;
          flex-direction: column;
          .img_title {
            height: 52px;
            font-size: 20px;
            font-weight: 500;
            line-height: normal;
            margin-bottom: 10px;
            letter-spacing: 0.4px;
            overflow: hidden; /* 超出部分将被隐藏 */
            display: -webkit-box; /* 必需的WebKit前缀 */
            -webkit-line-clamp: 2; /* 限制显示的行数为2行 */
            -webkit-box-orient: vertical; 
          }
          .img_date {
            font-size: 16px;
            font-weight: 500;
            line-height: normal;
            letter-spacing: 0.32px;
          }
        }
      }
    }
    .seeMore {
      display: table;
      font-size: 18px;
      cursor: pointer;
      font-weight: 500;
      line-height: 20px;
      padding: 10px 50px;
      margin: 20px auto 0;
      border-radius: 20px;
      letter-spacing: 0.08em;
      backdrop-filter: blur(6px);
      color: rgb(255, 255, 255);
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>

<style>
.el-carousel__mask {
  background: rgba(0, 0, 0, 1) !important;
  border-radius: 50px;
  overflow: hidden;
  opacity: .6;
}
</style>